export default "__VITE_ASSET__KioRpNlv__"